var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessages2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 53,
    viewBox: "0 0 46 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/messages-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.427734,
    width: 46,
    height: 52,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.6201 22.8777C30.5701 18.2577 26.5401 16.1777 23.0001 16.1777C23.0001 16.1777 23.0001 16.1777 22.9901 16.1777C19.4601 16.1777 15.4201 18.2477 14.3701 22.8677C13.2001 28.0277 16.3601 32.3977 19.2201 35.1477C20.2801 36.1677 21.6401 36.6777 23.0001 36.6777C24.3601 36.6777 25.7201 36.1677 26.7701 35.1477C29.6301 32.3977 32.7901 28.0377 31.6201 22.8777Z",
    fill: "#4059C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.9996 27.8879C24.7393 27.8879 26.1496 26.4776 26.1496 24.7379C26.1496 22.9982 24.7393 21.5879 22.9996 21.5879C21.2599 21.5879 19.8496 22.9982 19.8496 24.7379C19.8496 26.4776 21.2599 27.8879 22.9996 27.8879Z",
    fill: "#D7DDFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages2);
export default __webpack_public_path__ + "static/media/messages-2.97aeb440926dcaf15d97f3b0e13f59d3.svg";
export { ForwardRef as ReactComponent };